import Scriba from 'react-scriba';

export class DataNews {
    static _onChargementNews(filterBy, include, sortedColumn, isSortedDescending) {
        const objet = {
            filterBy: filterBy || {},
            include: include || {},
            sortedColumn: sortedColumn,
            isSortedDescending: isSortedDescending
        };
        const url = "api/Liste/ListeDesNews";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onEnregistrementNews(news) {
        const url = "api/MAJDonnees/EnregistrementNews";
        const paramPost = Scriba.fetch().createParameterPost(news);

        return fetch(url, paramPost).then(response => response.json());
    }

    static _onSuppressionNews(idNews) {
        const objet = { "idNews": idNews };
        const url = "api/MAJDonnees/SuppressionNews";
        const paramPost = Scriba.fetch().createParameterPost(objet);

        return fetch(url, paramPost).then(response => response.json());
    }
}
